module.exports = __webpack_public_path__ + "img/4-mob.90e59180.svg";